import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-SG1E1T0PHK"); // Đã cập nhật Measurement ID của bạn
};

export const sendPageView = (path: string) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const sendSectionEvent = (section: string) => {
  ReactGA.event({
    category: "Section",
    action: "View",
    label: section,
  });
};
